module.exports = __webpack_public_path__ + "img/orders-active-ic.1a95901d.svg";